/*
 * URLs de las imágenes subidas.
 *
 * Cada imagen existe dos veces con el mismo nombre:
 *  - /img/minGallery/  miniatura ligera (≤ 640 px, ~35-45 KB): rejillas, tarjetas, listados
 *  - /img/gallery/     versión grande (≤1920 px): pantalla completa, portada, popups
 *
 * La base se configura con VUE_APP_MEDIA_URL (.env.development / .env.production).
 * Si no se define, se usa el mismo dominio que sirve la web.
 */

export const MEDIA_URL = (process.env.VUE_APP_MEDIA_URL || `${window.location.protocol}//${window.location.host}`).replace(/\/+$/, "");

const esAbsoluta = (nombre) => /^https?:\/\//i.test(nombre || "");

export function urlMiniatura(nombre) {
  if (!nombre) return "";
  return esAbsoluta(nombre) ? nombre : `${MEDIA_URL}/img/minGallery/${nombre}`;
}

export function urlGrande(nombre) {
  if (!nombre) return "";
  return esAbsoluta(nombre) ? nombre : `${MEDIA_URL}/img/gallery/${nombre}`;
}

/**
 * v-img-fallback: si falta la miniatura, carga la versión grande (una sola vez).
 * Escucha en fase de captura para actuar antes que los @error del componente,
 * que suelen ocultar la imagen.
 */
export const imgFallback = {
  bind(el) {
    el.__imgFallback = (event) => {
      if (el.dataset.fallback || !el.src.includes("/img/minGallery/")) return;
      el.dataset.fallback = "1";
      event.stopImmediatePropagation();
      el.src = el.src.replace("/img/minGallery/", "/img/gallery/");
    };
    el.addEventListener("error", el.__imgFallback, true);
  },
  componentUpdated(el) {
    // Si el componente cambia de imagen, se permite un nuevo intento
    if (el.dataset.fallback && el.src.includes("/img/minGallery/")) delete el.dataset.fallback;
  },
  unbind(el) {
    el.removeEventListener("error", el.__imgFallback, true);
    delete el.__imgFallback;
  },
};
